export default "__VITE_ASSET__DYKKRTo___"